import {SecurityVulnerability} from "./security-vulnerability";
import {Utils} from '../../../shared/utils/utils';

export class SecurityVulnerabilityMapper {

  public static map(data: any): SecurityVulnerability {
    const securityVulnerability: SecurityVulnerability = new SecurityVulnerability();
    securityVulnerability.id = data.id;
    securityVulnerability.title = data.title;
    securityVulnerability.type = data.vuln_type === 'OBJECTINJECTION' ? 'OBJECT INJECTION' : data.vuln_type;
    securityVulnerability.createDate = data.created_at ? Utils.getDate(data.created_at) : null;
    securityVulnerability.updateDate = data.updated_at ? Utils.getDate(data.updated_at) : null;
    securityVulnerability.publishedDate = data.published_date ? Utils.getDate(data.published_date) : null;
    securityVulnerability.references = data.references && data.references.url ? data.references.url.map((reference) => reference) : [];
    securityVulnerability.fixedIn = data.fixed_in;

    return securityVulnerability;
  }

}
